(function() {
  function initProductInventory() {
    document.querySelectorAll('[data-c-product-inventory]').forEach(function(cInventory) {
      var productSection = cInventory.closest('[id^="ProductSection-"]');
      var cInventoryText = cInventory.querySelector('[data-c-product-inventory-text]');
      if (!productSection || !cInventoryText) return;

      productSection.addEventListener('variantChange', function(event) {
        var variant = event.detail.variant;
        var isAvailable = variant && variant.available;

        cInventoryText.textContent = isAvailable ? 'あり' : 'なし';
        cInventory.setAttribute(
          'data-c-product-inventory-state',
          isAvailable ? 'in-stock' : 'sold-out'
        );
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductInventory);
  } else {
    initProductInventory();
  }
})();
